import { EMPTY_SELECT_OPTION } from 'Constants/form'

import type { ReassignDeviceModalFormSchema } from './ReassignDeviceModal.types'

export const reassignDeviceFormDefaultValues: ReassignDeviceModalFormSchema = {
  employee: EMPTY_SELECT_OPTION,
}
